module.exports = __webpack_public_path__ + "static/img/tscar2.718a83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tscar2.png
// module id = +5C1
// module chunks = 1